import { QuestionCircleOutlined } from '@ant-design/icons'
import { Flex, Tooltip } from 'antd'
import { ReactNode } from 'react'

interface Props {
  title: ReactNode
  tooltip: ReactNode
}

export const CardTitleWithTooltip = ({ title, tooltip }: Props) => (
  <Flex align="center" gap={8}>
    <span>{title}</span>
    <Tooltip title={tooltip}>
      <QuestionCircleOutlined style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 14 }} />
    </Tooltip>
  </Flex>
)
